/* eslint-disable */

const handleError = (error) => {
  return error.response.data.error;
};

export default handleError;
